(function () {
  function getRoutesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function initVinacaveCart(section) {
    if (!section || section.dataset.vcReady === 'true') return;
    section.dataset.vcReady = 'true';

    var form = section.querySelector('.vc-cart-form');
    var updateTimer;

    section.querySelectorAll('.vc-cart-qty').forEach(function (quantity) {
      var input = quantity.querySelector('.vc-cart-qty__input');
      var minus = quantity.querySelector('[data-action="minus"]');
      var plus = quantity.querySelector('[data-action="plus"]');

      function submitUpdate() {
        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(function () {
          if (!form) return;

          var hiddenUpdate = document.createElement('input');
          hiddenUpdate.type = 'hidden';
          hiddenUpdate.name = 'update';
          hiddenUpdate.value = 'Mettre à jour';
          form.appendChild(hiddenUpdate);
          form.submit();
        }, 250);
      }

      if (minus) {
        minus.addEventListener('click', function () {
          input.value = Math.max(0, parseInt(input.value || '0', 10) - 1);
          submitUpdate();
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          input.value = parseInt(input.value || '0', 10) + 1;
          submitUpdate();
        });
      }

      if (input) {
        input.addEventListener('change', submitUpdate);
      }
    });

    initPromoCode(section);
  }

  function initPromoCode(section) {
    var promo = section.querySelector('[data-vc-promo]');
    if (!promo) return;

    var input = promo.querySelector('[data-vc-promo-input]');
    var applyButton = promo.querySelector('[data-vc-promo-apply]');
    var removeButton = promo.querySelector('[data-vc-promo-remove]');
    var activeBox = promo.querySelector('[data-vc-promo-active]');
    var activeCode = promo.querySelector('[data-vc-promo-code]');
    var message = promo.querySelector('[data-vc-promo-message]');
    var toggleButton = promo.querySelector('[data-vc-promo-toggle]');
    var panel = promo.querySelector('[data-vc-promo-panel]');
    var storageKey = 'vinacave_discount_code';

    function setPanelOpen(isOpen) {
      if (!toggleButton || !panel) return;
      toggleButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.hidden = !isOpen;

      if (isOpen && input) {
        window.setTimeout(function () {
          input.focus();
        }, 50);
      }
    }

    function normalizeCode(value) {
      return String(value || '').trim().toUpperCase();
    }

    function setLoading(isLoading) {
      if (input) input.disabled = isLoading;
      if (applyButton) {
        applyButton.disabled = isLoading;
        applyButton.textContent = isLoading ? 'Validation…' : 'Appliquer';
      }
      if (removeButton) removeButton.disabled = isLoading;
    }

    function showMessage(text, type) {
      if (!message) return;
      message.textContent = text || '';
      message.classList.remove('is-success', 'is-error');

      if (type) {
        message.classList.add(type === 'success' ? 'is-success' : 'is-error');
      }
    }

    function showActiveCode(code) {
      var normalized = normalizeCode(code);
      if (!activeBox || !activeCode) return;

      if (normalized) {
        activeCode.textContent = normalized;
        activeBox.hidden = false;

        if (toggleButton) toggleButton.hidden = true;
        if (panel) panel.hidden = true;
        if (input) input.value = '';
      } else {
        activeCode.textContent = '';
        activeBox.hidden = true;

        if (toggleButton) toggleButton.hidden = false;
        setPanelOpen(false);
      }
    }

    function getDiscountCodes(cart) {
      if (!cart || !Array.isArray(cart.discount_codes)) return [];
      return cart.discount_codes
        .filter(function (discount) {
          return discount && discount.code && discount.applicable !== false;
        })
        .map(function (discount) {
          return normalizeCode(discount.code);
        });
    }

    function updateDiscount(code) {
      return fetch(getRoutesRoot() + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ discount: code })
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'La réduction n’a pas pu être appliquée.');
          }
          return data;
        });
      });
    }

    function applyCode() {
      var code = normalizeCode(input && input.value);

      if (!code) {
        showMessage('Saisissez votre code privilège.', 'error');
        if (input) input.focus();
        return;
      }

      setLoading(true);
      showMessage('');

      updateDiscount(code)
        .then(function (cart) {
          var codes = getDiscountCodes(cart);
          var isApplicable = codes.indexOf(code) !== -1;

          if (!isApplicable) {
            window.sessionStorage.removeItem(storageKey);
            showActiveCode('');
            showMessage('Ce code est invalide ou ne s’applique pas à cette sélection.', 'error');
            return;
          }

          window.sessionStorage.setItem(storageKey, code);
          showActiveCode(code);
          showMessage('Votre code privilège a bien été appliqué.', 'success');

          window.setTimeout(function () {
            window.location.reload();
          }, 450);
        })
        .catch(function (error) {
          showMessage(error.message || 'Une erreur est survenue. Réessayez.', 'error');
        })
        .finally(function () {
          setLoading(false);
        });
    }

    function removeCode() {
      setLoading(true);
      showMessage('');

      updateDiscount('')
        .then(function () {
          window.sessionStorage.removeItem(storageKey);
          showActiveCode('');
          showMessage('Le code privilège a été retiré.', 'success');

          window.setTimeout(function () {
            window.location.reload();
          }, 350);
        })
        .catch(function (error) {
          showMessage(error.message || 'Le code n’a pas pu être retiré.', 'error');
        })
        .finally(function () {
          setLoading(false);
        });
    }

    var savedCode = normalizeCode(window.sessionStorage.getItem(storageKey));
    if (savedCode) {
      showActiveCode(savedCode);
    }

    if (toggleButton) {
      toggleButton.addEventListener('click', function () {
        var isOpen = toggleButton.getAttribute('aria-expanded') === 'true';
        setPanelOpen(!isOpen);
      });
    }

    if (applyButton) {
      applyButton.addEventListener('click', applyCode);
    }

    if (removeButton) {
      removeButton.addEventListener('click', removeCode);
    }

    if (input) {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          applyCode();
        }
      });
    }
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-vc-cart-section]').forEach(initVinacaveCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
